import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';

const Hero = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={0}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '16vh',
          }}
        />
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          variant="overline"
          color="textSecondary"
          align="center"
          display="block"
          gutterBottom
        >
          Propuesta Comercial
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h3"
          gutterBottom
          align="center"
          color={theme.palette.primary.main}
        >
          Bancaribe & TNO Network
        </Box>
        <Typography
          variant="h6"
          component="p"
          color="textSecondary"
          align="center"
          sx={{ fontStyle: 'italic', mb: 3 }}
        >
          Tecnología con Propósito: Humanizando la Banca Digital
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          <Box
            component="img"
            src="/images/Logo-Bancaribe-nuevo.png"
            alt="Bancaribe"
            sx={{ maxWidth: 200, height: 'auto', objectFit: 'contain' }}
          />
        </Box>
        <Box
          sx={{
            maxWidth: 720,
            mx: 'auto',
            py: 2,
            px: 2,
            borderRadius: 2,
            bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
          }}
        >
          <Typography
            variant="h6"
            component="p"
            color="textSecondary"
            align="center"
            gutterBottom
          >
            <strong>Análisis de Oportunidad</strong>
          </Typography>
          <Typography variant="body1" color="textSecondary" align="center">
            Bancaribe, con 71 años de solidez, lidera hoy la transformación financiera en Venezuela. El reto actual es la <strong>adopción digital</strong>: que el usuario confíe y use las herramientas (App, Divisas, Pago Móvil). <strong>Punto de Fe</strong> ofrece el entorno de valores y ética necesario para que la tecnología de Bancaribe sea percibida como un facilitador de bienestar y no como un proceso frío.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

Hero.propTypes = {
  themeMode: PropTypes.string,
};

export default Hero;
